var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3136",
    "data-name": "Group 3136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.229,
    height: 20.229,
    viewBox: "0 0 20.229 20.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3135",
    "data-name": "Group 3135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M4.554,13.867a6.855,6.855,0,1,0-2.705-2.705",
    transform: "translate(2.257 2.257)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M4.553,15.56,1,16.408l.848-3.553",
    transform: "translate(2.257 0.564)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M5.883,8.9a.624.624,0,1,1-.623-.623A.623.623,0,0,1,5.883,8.9Z",
    transform: "translate(1.738 1.218)",
    fill: "none",
    stroke: "#16161a",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M9.519,8.9A.624.624,0,1,1,8.9,8.273.623.623,0,0,1,9.519,8.9Z",
    transform: "translate(1.218 1.218)",
    fill: "none",
    stroke: "#16161a",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M13.156,8.9a.624.624,0,1,1-.623-.623A.623.623,0,0,1,13.156,8.9Z",
    transform: "translate(0.699 1.218)",
    fill: "none",
    stroke: "#16161a",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.2617f937fe1b0c0079634d6515f8c934.svg";
export { ForwardRef as ReactComponent };